import React from "react";
import BarraSupDent from "../../commons/BarraSupDent";
import Title from "../Login/Components/title/title";
import "../Time/Components/ButtonTime.css";
import ButtonOptions from "./Components/ButtonOptions";
import firebaseManager from "../../model/Firebase/FirebaseManager";
import NavbarDownConsumer from "../../commons/NavbarDownConsumer";
import moment from "moment";

class New_time extends React.Component {
  constructor(props) {
    super(props);

    this.mondayOptions = React.createRef();
    this.tuesdayOptions = React.createRef();
    this.wednesdayOptions = React.createRef();
    this.thursdayOptions = React.createRef();
    this.fridayOptions = React.createRef();
    this.saturdayOptions = React.createRef();
    this.sundayOptions = React.createRef();
    this.state = {
      info_time: [],
    };
  }

  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        ele.classList.add("available");
        setTimeout(() => {
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }

  handleContinue = () => {
    let selectedDays = [];
    selectedDays = selectedDays.concat(
      this.mondayOptions.current.getSelectedDays()
    );
    selectedDays = selectedDays.concat(
      this.tuesdayOptions.current.getSelectedDays()
    );
    selectedDays = selectedDays.concat(
      this.wednesdayOptions.current.getSelectedDays()
    );
    selectedDays = selectedDays.concat(
      this.thursdayOptions.current.getSelectedDays()
    );
    selectedDays = selectedDays.concat(
      this.fridayOptions.current.getSelectedDays()
    );
    selectedDays = selectedDays.concat(
      this.saturdayOptions.current.getSelectedDays()
    );
    selectedDays = selectedDays.concat(
      this.sundayOptions.current.getSelectedDays()
    );

    firebaseManager.confirmTime(
      selectedDays,
      this.succesConfirmTime,
      this.failConfirmTime
    );
  };

  succesConfirmTime = () => {
    window.location = "/home";
  };

  failConfirmTime(error) {
    alert(error.message);
  }
  render() {
    let monday = moment().locale("en").format("dddd, Do/MM");
    let tuesday = moment().add(1, "day").format("dddd, Do/MM");
    let wednesday = moment().add(2, "day").format("dddd, Do/MM");
    let thursday = moment().add(3, "day").format("dddd, Do/MM");
    let friday = moment().add(4, "day").format("dddd, Do/MM");
    let saturday = moment().add(5, "day").format("dddd, Do/MM");
    let sunday = moment().add(6, "day").format("dddd, Do/MM");
    return (
      <React.Fragment>
        <BarraSupDent />
        <Title
          text1="When do you want it fixed?"
          text2="Select as many as you'd like, we will try to service you as soon as possible."
        />
        <div className="timeContenedor mx-auto">
          <ButtonOptions
            id={"monday"}
            hora1={"8 - 11am"}
            hora2={"11 - 3pm"}
            hora3={"3 to 7pm"}
            day={monday}
            ref={this.mondayOptions}
          />
          <ButtonOptions
            id={"tuesday"}
            hora1={"8 - 11am"}
            hora2={"11 - 3pm"}
            hora3={"3 to 7pm"}
            day={tuesday}
            ref={this.tuesdayOptions}
          />
          <ButtonOptions
            id={"wednesday"}
            hora1={"8 - 11am"}
            hora2={"11 - 3pm"}
            hora3={"3 to 7pm"}
            day={wednesday}
            ref={this.wednesdayOptions}
          />
          <ButtonOptions
            id={"thursday"}
            hora1={"8 - 11am"}
            hora2={"11 - 3pm"}
            hora3={"3 to 7pm"}
            day={thursday}
            ref={this.thursdayOptions}
          />
          <ButtonOptions
            id={"friday"}
            hora1={"8 - 11am"}
            hora2={"11 - 3pm"}
            hora3={"3 to 7pm"}
            day={friday}
            ref={this.fridayOptions}
          />
          <ButtonOptions
            id={"saturday"}
            hora1={"8 - 11am"}
            hora2={"11 - 3pm"}
            hora3={"3 to 7pm"}
            day={saturday}
            ref={this.saturdayOptions}
          />
          <ButtonOptions
            id={"sunday"}
            hora1={"8 - 11am"}
            hora2={"11 - 3pm"}
            hora3={"3 to 7pm"}
            day={sunday}
            ref={this.sundayOptions}
          />
          <div className="text-center mt-4 mb-1">
            <button
              onClick={this.handleContinue}
              className="btn btn-secondary mx-auto mt-1"
            >
              Confirm new time
            </button>
          </div>
        </div>
        <div>
          <br />
          <br />
          <br />
          <br />
        </div>
        <NavbarDownConsumer />
      </React.Fragment>
    );
  }
}
export default New_time;
